import './Footer.css';

function Footer() {
  return (
   <footer className="site-footer">
  <div className="footer-content">
    <a href="https://www.facebook.com/share/1DRkiXzmaG/?mibextid=wwXIfr" className="footer-social">
      <i className="fab fa-facebook-f"></i>
    </a>

    <p className="footer-copy">
      © {new Date().getFullYear()} Celtic Plumbing & Heating
    </p>
  </div>
</footer>

  );
}

export default Footer;

